import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { TrainingGame } from 'types/games'
import { Link } from 'react-router-dom'
import { modalTitle as formatModalTitle } from 'utils/modal-title'

type Props = {
    data: TrainingGame[]
    onEdit: (id: number) => void
    onDelete: (id: number) => void
    loading: boolean
}

export const TrainingGamesTable = memo((props: Props) => {
    const { data, onEdit, onDelete, loading } = props

    const columns: ColumnsType<TrainingGame> = useMemo(
        () => [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
            },
            {
                title: 'Time range',
                key: 'timeRange',
                render: (_, record) => `${record.timeStart}-${record.timeEnd}`,
            },
            {
                title: 'Players count',
                dataIndex: 'playersCount',
                key: 'playersCount',
            },
            {
                title: 'Reserve players count',
                dataIndex: 'reservePlayersCount',
                key: 'reservePlayersCount',
            },
            {
                title: 'Field',
                key: 'field.id',
                render: (_, record) => record.field.name,
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => (
                    <Space size='middle'>
                        <Link
                            to={{
                                pathname: `/training-games/${record.id}`,
                            }}
                        >
                            Players
                        </Link>
                        <a onClick={() => onEdit(record.id)}>Edit</a>
                        <Popconfirm
                            title={formatModalTitle('Delete training game', `${record.field.name} ${record.date}`)}
                            description={'Are you sure to delete this training game?'}
                            onConfirm={() => onDelete(record.id)}
                            okText={'Yes'}
                            cancelText={'No'}
                        >
                            <a href='#'>Delete</a>
                        </Popconfirm>
                    </Space>
                ),
            },
        ],
        [onDelete, onEdit]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='id' pagination={false} />
})
